module.exports = __webpack_public_path__ + "static/media/icon-default.8b187f86.svg";